import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Intercepts HTTP calls and makes sure it authenticates using an API Key
 */
@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  /**
   * Intercepts HTTP calls and makes sure it authenticates using an API Key
   * @param req The request
   * @param next HttpHandler
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const normalizedEndpoint = req.url.toLowerCase().trim();//simplified "normalize" from azure-msal-angular
    if (!normalizedEndpoint.startsWith('http')) {
      return next.handle(req);
    }

    const protectedResourcesArray = Array.from(environment.AzureProtectedResourceMap.keys());
    const keyMatchesEndpointArray = protectedResourcesArray.filter(key => {
      const normalizedKey = key.toLowerCase().trim();
      return normalizedEndpoint.startsWith(normalizedKey);
    });
    if (keyMatchesEndpointArray.length === 0) {
      //resource is not protected
      return next.handle(req);
    }
    const _window: any = window;
    const apiKeyInfo = _window.apiKeyInfo;

    const authReq = req.clone({
      headers: req.headers.set(`${apiKeyInfo.header}`, `${apiKeyInfo.secret}`)
    });

    return next.handle(authReq);
  }
}
